import { render, staticRenderFns } from "./WorkingHolidayChip.vue?vue&type=template&id=550a0bea"
import script from "./WorkingHolidayChip.vue?vue&type=script&lang=js"
export * from "./WorkingHolidayChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports